export default __webpack_public_path__ + "img/4dbdcbbe43c659a38b36805208ba4137.svg";